export default __webpack_public_path__ + "static/2-9314e7b082c2c716ae2b007276bd3d47.png";